import { FaFolder, FaLandmark, FaRoute, FaStar } from 'react-icons/fa';
import { LinkNavegacion } from './../Utils/LinkNavegacion';

const MenuInformeDdhh = () => {

return (
    <div className="card">
        <div className="card-header">
            <h2>Informes DDHH</h2>
        </div>
        <div className="card-body">
            <div className="row">
                <div>
                    <LinkNavegacion enlace={'/ddhh/informes/casosnuevos'} titulo="Casos nuevos" icon={FaStar} />
                    <LinkNavegacion enlace={'/ddhh/informes/seguimiento'} titulo="Seguimiento" icon={FaRoute} />
                    <LinkNavegacion enlace={'/ddhh/informes/audiencias'} titulo="Audiencias" icon={FaLandmark} />
                    <LinkNavegacion enlace={'/ddhh/informes/finalizados'} titulo="Finalizados" icon={FaFolder} />
                </div>
            </div>
        </div>
    </div>
);
};

export default MenuInformeDdhh;